import React, { useMemo, useEffect, useState } from "react";
import { useCallLink } from "./CallLinks";
import { skipToken } from '@reduxjs/toolkit/query'
import { useGetSystemsQuery, useGetTalkgroupsQuery } from '../../features/api/apiSlice'
import { useDispatch } from 'react-redux'
import { setRidTag } from "../../features/calls/callsSlice";
import {  useParams } from 'react-router-dom';
import {
  Header,
  Divider,
  List,
  Statistic,
  Icon,
  Menu,
  Label,
  Input
} from "semantic-ui-react";

const MAX_RID_TAG_LENGTH = 40;

// ----------------------------------------------------
function CallInfoPane(props) {


  let srcList = "";
  let callLength = "-";
  let callFreq = "-";
  let callDate = "-";
  let callTime = "-";
  let talkgroupNum = "-";
  let header = "Call Info"
  let title = ""
  const currentCall = props.call ? props.call : false;
  const { callDownload, callTweet } = useCallLink(props.call)
  const { data: allSystems, isSuccess } = useGetSystemsQuery();
  const dispatch = useDispatch();
  // srcTags overrides the tag that came down with currentCall - currentCall is a snapshot the
  // parent hands us when a call starts playing, so it won't update just because a rid mutation
  // resolved. Keyed by source.src.
  const [srcTags, setSrcTags] = useState({});
  const [editingSrc, setEditingSrc] = useState(null);
  const [editValue, setEditValue] = useState("");
  let { shortName } = useParams();
  if (!shortName && currentCall) {
    shortName = currentCall.shortName;
  }

  useEffect(() => {
    setSrcTags({});
    setEditingSrc(null);
    setEditValue("");
  }, [currentCall ? currentCall._id : null]);

  const handleStartEditTag = (src, currentTag) => {
    setEditingSrc(src);
    setEditValue(currentTag && currentTag !== 'N/A' ? currentTag : "");
  }

  const handleSaveTag = (src) => {
    const tag = editValue.trim();
    if (!tag) {
      return;
    }
    setEditingSrc(null);
    dispatch(setRidTag({ rid: src, tag })).unwrap().then((res) => {
      if (res.success) {
        setSrcTags((prev) => ({ ...prev, [src]: res.tag }));
      }
    });
  }

  const { data: talkgroupsData, isSuccess: isTalkgroupsSuccess } = useGetTalkgroupsQuery(shortName ? shortName : skipToken);

  if (currentCall) {
    if ((talkgroupsData) && talkgroupsData.talkgroups[currentCall.talkgroupNum]) {
      header = talkgroupsData.talkgroups[currentCall.talkgroupNum].description;
      title = talkgroupsData.talkgroups[currentCall.talkgroupNum].description;
    } else {
      title = `TG: ${currentCall.talkgroupNum}`;
    }
    const time = new Date(currentCall.time);
    callTime = time.toLocaleTimeString();
    callDate = time.toLocaleDateString();
    if (currentCall.freq) {
      const freq = currentCall.freq / 1000000;
      callFreq = Math.round(freq * 1000) / 1000;
    }
    srcList = currentCall.srcList.map((source, index) => {
      const tag = srcTags[source.src] || source.tag;
      const isEditing = editingSrc === source.src;
      return (
        <List.Item key={index}>
          {isEditing ? (
            <Input
              autoFocus
              size='mini'
              action={{ icon: 'checkmark', onClick: () => handleSaveTag(source.src) }}
              placeholder='Unit name...'
              maxLength={MAX_RID_TAG_LENGTH}
              value={editValue}
              onChange={(e) => setEditValue(e.target.value)}
              onClick={(e) => e.preventDefault()}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleSaveTag(source.src);
                } else if (e.key === 'Escape') {
                  setEditingSrc(null);
                }
              }}
            />
          ) : (
            <Label
              as='a'
              tag
              size='small'
              onClick={() => handleStartEditTag(source.src, tag)}
            >
              {tag}<Icon name='pencil' style={{ marginLeft: '4px' }} />
            </Label>
          )} {source.src}
        </List.Item>
      );
    });
    callLength = currentCall.len;
    talkgroupNum = currentCall.talkgroupNum;

  }
  let system = false;
  if (allSystems) {
    system =  allSystems.systems.find((system) => system.shortName === shortName)
  } 

/*
  let system = useMemo(() => {
    if (allSystems) {
      return allSystems.systems.find((system) => system.shortName === currentCall.shortName)
    } else {
      return false;
    }
  }, [allSystems, currentCall.shortName])*/

  useEffect(() => {
    // When audio starts playing...
    if ('mediaSession' in navigator) {

      navigator.mediaSession.metadata = new MediaMetadata({
        title: title,
        album: 'OpenMHz',
        artist: system ? system.name : "",
        artwork: [
          { src: '/favicon-32x32.png', sizes: '32x32', type: 'image/png' },
          { src: '/android-chrome-192x192.png', sizes: '192x192', type: 'image/png' },
          { src: '/android-chrome-192x192.png', sizes: '512x512', type: 'image/png' },
        ]
      });
    }
  }, [currentCall])




  return (
    <>
      <Header as='h1'>{header}</Header>
      <List bulleted horizontal link>
        {srcList}
      </List>
      <Divider />
      <Statistic size='small'>
        <Statistic.Label>Seconds</Statistic.Label>
        <Statistic.Value>{callLength}</Statistic.Value>
      </Statistic>
      <Statistic size='small'>
        <Statistic.Label>Talkgroup</Statistic.Label>
        <Statistic.Value>{talkgroupNum}</Statistic.Value>
      </Statistic>

      <List divided verticalAlign='middle'>
        <List.Item>
          <Icon name="wait" />
          <List.Content>
            {callTime}
          </List.Content>
        </List.Item>
        <List.Item>
          <Icon name="calendar outline" />
          <List.Content>
            {callDate}
          </List.Content>
        </List.Item>
        <List.Item>
          <Icon name="cubes" />
          <List.Content>
            {callFreq} MHz
          </List.Content>
        </List.Item>
      </List>
      <Divider />
      <Menu secondary fluid widths={2}>
        <Menu.Item name="download" href={callDownload}><Icon name="download" />Download</Menu.Item>
        <Menu.Item name="link" href={callDownload}><Icon name="at" />Link</Menu.Item>
      </Menu>
    </>
  );
}

export default CallInfoPane;
